// extracted by mini-css-extract-plugin
export default {"container":"OB-z","modal":"PB-z","dimensions":"QB-z","brandName":"RB-z","productName":"SB-z","labelValue":"TB-z","recipientEmail":"UB-z","recommendedFit":"VB-z","hiddenField":"WB-z"};